<template lang="pug">
    div.form-group-layout.form-group
        slot(:invalid='invalid' :errors='errors' :touch='touch' :delayedTouch='delayedTouch')
</template>

<script>
import {template, templateSettings} from 'lodash'

templateSettings.interpolate = /{{([\s\S]+?)}}/g

const TEMPLATES_MAP = {
    // alpha: "Alphanumeric characters only.",
    // minLength: "Must have a length no less than {{min}}.",
    required: '{{label}} is required.',
    unique: 'The {{label}} has already been taken.',
    email: 'Not a valid e-mail address.',
    url: 'Not a valid URL.',
    slug: 'Not a valid slug (only "-" and alphanumeric characters).',
    decimal: 'Not a valid decimal number.',
    between: 'Number should be between {{min}} and {{max}}.',
}

export default {
    name: 'form-group-layout',
    props: {
        v: {
            validator: v => !v || typeof(v) == 'object' || v === true,
        },
        serverErrors: {
            type: Array,
        },
        label: {
            type: String,
        },
        labelShort: {
            type: String,
        },
    },
    data() {
        return {
            touchTimer: null,
            hideServerErrors: false,
        }
    },
    computed: {
        invalid() {
            if (this.v === true) {
                return false
            }
            if (this.v === false) {
                return true
            }

            if (!this.v) {
                return false
            }

            if (!this.v.$dirty) {
                return false
            }

            const isPending = this.v.$pending

            for (const validator of Object.keys(this.v.$params)) {
                const isValid = this.v[validator]
                const isAsync = this.v.$params[validator] && this.v.$params[validator].async === true

                if (!isValid && (!isAsync || !isPending)) {
                    return true
                }
            }

            if (!this.hideServerErrors && this.serverErrors && this.serverErrors.length) {
                return true
            }

            return false
        },
        errors() {
            if (!this.invalid || typeof(this.v) == 'boolean') {
                return []
            }

            const allErrors = Object.keys(this.v.$params).reduce(
                (errors, validator) => {
                    if (!this.v[validator] && ((this.v.$params[validator] && !this.v.$params[validator].async) || !this.v.$pending)) {
                        const compiled = template(TEMPLATES_MAP[validator])
                        errors.push(compiled({
                            ...this.v.$params[validator],
                            ...{
                                label: this.labelShort || this.label,
                            },
                        }))
                    }
                    return errors
                },
                []
            )

            if (!this.hideServerErrors && this.serverErrors) {
                this.serverErrors.forEach(e => allErrors.push(e))
            }

            return allErrors
        },
    },
    watch: {
        serverErrors() {
            this.hideServerErrors = false
        },
    },
    methods: {
        touch() {
            if (this.v && this.v !== true) {
                this.v.$touch()
                this.hideServerErrors = true
            }
        },
        delayedTouch() {
            if (this.v && this.v !== true) {
                clearTimeout(this.touchTimer)
                this.touchTimer = setTimeout(() => {
                    this.touch()
                }, 1250)
            }
        },
    },
}
</script>
